import { RootContextProps } from 'components/RootContainer';
import { Crumb } from 'components/TranslatableCrub';
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import financialAccountRoutes from '../pages/FinancialAccountModule/routes';

const StayCardPage = lazy(() => import('../pages/StayCardPage'));

const CreateReservationPageNew = lazy(() => import('../pages/CreateReservationPageNew'));

const ReservationListPage = lazy(() => import('../pages/ReservationListPage'));

const ForecastPage = lazy(() => import('../pages/ForecastPage'));

const reservationRoutes = (api: RootContextProps): RouteObject[] => [
  {
    index: true,
    element: (
      <Suspense fallback={<>...</>}>
        <ReservationListPage />
      </Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="reservation.breadcrubms.find-reservation" path={null} />,
    },
  },
  {
    path: 'create-reservation',
    element: (
      <Suspense fallback={<>...</>}>
        <CreateReservationPageNew key="create-reservation" />
      </Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="reservation.breadcrubms.create-reservation" path={null} />,
    },
  },
  {
    path: ':id/edit-reservation',
    element: (
      <Suspense fallback={<>...</>}>
        <CreateReservationPageNew key="edit-reservation" />
      </Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="reservation.breadcrubms.find-reservation" path={null} />,
    },
  },

  {
    path: 'stay-card/:guestId/:voucher/:confirmationNumber',
    element: (
      <Suspense fallback={<>...</>}>
        <StayCardPage />
      </Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="reservation.breadcrubms.stay-card" path={null} />,
    },
  },

  {
    path: 'forecast',
    element: (
      <Suspense fallback={<>...</>}>
        <ForecastPage />
      </Suspense>
    ),
    handle: {
      crumb: () => <Crumb label="reservation.breadcrubms.forcast-available-room" path={null} />,
    },
  },

  {
    path: 'financial-account',
    children: financialAccountRoutes(),
  },
  // {
  //   path: 'financial-account',
  //   element: (
  //     <Suspense fallback={<>...</>}>
  //       <FinancialAccountPage />
  //     </Suspense>
  //   ),
  //   handle: {
  //     crumb: () => <Crumb label="frontDesk:financialAccount" />,
  //   },
  // },
  // {
  //   path: FINANCIAL_ACCOUNT_FORM_PATH,
  //   element: (
  //     <Suspense fallback={<>...</>}>
  //       <FinancialAccountForm />
  //     </Suspense>
  //   ),
  //   handle: {
  //     crumb: () => <Crumb label="frontDesk:financialAccount" />,
  //   },
  // },

  // {
  //   path: 'financial-account/:guestId/:accountNumber',
  //   element: (
  //     <Suspense fallback={<>...</>}>
  //       <FinancialAccountChargeGroup />
  //     </Suspense>
  //   ),
  //   handle: {
  //     crumb: () => <Crumb label="Financial Account . Charges And Payments" path={null} />,
  //   },
  // },
];

export default reservationRoutes;
